import { useBlockExtender } from "@hooks";
import { useAppLayout } from "@providers";
import { messageBlockConfig } from "./config";

export const MessageBlock = () => {
  const { sidebarCollapsed } = useAppLayout();
  const extender = useBlockExtender(messageBlockConfig, {});
  return sidebarCollapsed ? null : extender;
};
